if (!customElements.get("rook-product-tabs")) {
  class MProductTabs extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        loadMoreBtn: "[data-load-more-product]",
        productsContainer: "[data-products-container]",
        tabContent: [".rook-tab-content"],
      };
      this.tabSliders = [];
      this.sliderEnabled = this.dataset.enableSlider === "true";
      this.mobileSliderDisable = this.dataset.mobileDisableSlider === "true";
      this.buttonType = this.dataset.buttonType;
      this.domNodes = queryDomNodes(this.selectors, this);
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.items = this.dataset.items;
      this.mobileDeck = this.dataset.mobileDeck === "true";
    }

    connectedCallback() {
      this.init();
    }

    init() {
      if (this.sliderEnabled) {
        for (let block of this.domNodes.tabContent) {
          this.initSliderByScreenSize(block);
          document.addEventListener("matchMobile", () => {
            this.initSliderByScreenSize(block);
          });
          document.addEventListener("unmatchMobile", () => {
            this.initSliderByScreenSize(block);
          });
        }
      }
      if (!this.sliderEnabled && this.buttonType === "load") {
        this.canLoad = true;
        this.currentPage = 1;

        for (let block of this.domNodes.tabContent) {
          this.initLoadMore(block);
        }
      }
      if (RookTheme.config.mqlMobile && this.mobileSliderDisable && this.buttonType === "load") {
        this.canLoad = true;
        this.currentPage = 1;
        for (let block of this.domNodes.tabContent) {
          this.initLoadMore(block);
        }
      }
      document.addEventListener("matchMobile", () => {
        if (RookTheme.config.mqlMobile && this.mobileSliderDisable && this.buttonType === "load") {
          this.canLoad = true;
          this.currentPage = 1;
          for (let block of this.domNodes.tabContent) {
            this.initLoadMore(block);
          }
        }
      });
      this.initTabs();
      this.initMobileSelect();

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const blockSelectedIsTab = event.target.classList.contains("rook-tab-content");
          if (!blockSelectedIsTab) return;
          const dataIndex = event.target && event.target.dataset.index;
          this.tabs.setActiveTab(dataIndex);
        });
      }
    }

    initTabs() {
      this.tabs = new RookTheme.Tabs(this, (target) => {
        const tabId = target.getAttribute("href");
        const slider = this.querySelector(tabId + " .swiper-container");
        const controlsContainer = this.querySelector(tabId + " .rook-slider-controls");
        // trigger update slider
        slider && slider.swiper && slider.swiper.update();
        const firstItem = slider && (slider.querySelector(".rook-image") || slider.querySelector(".rook-placeholder-svg"));
        if (firstItem && controlsContainer) {
          const itemHeight = firstItem.clientHeight;
          controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");
        }
      });
    }

    initSliderByScreenSize(sliderContainer) {
      const mobileDisableSlider = this.dataset.mobileDisableSlider === "true";
      const slider = sliderContainer.querySelector(".rook-mixed-layout__wrapper");
      const controlsContainer = sliderContainer.querySelector(".rook-slider-controls");

      if (RookTheme.config.mqlMobile && mobileDisableSlider) {
        controlsContainer && controlsContainer.classList.add("rook:hidden");
        slider.classList.remove("swiper-container");
        if (slider.swiper) slider.swiper.destroy(false, true);
      } else {
        controlsContainer && controlsContainer.classList.remove("rook:hidden");
        setTimeout(() => {
          this.initSlider(sliderContainer);
        });
      }
    }

    initSlider(sliderContainer) {
      const layoutWrapper = sliderContainer.querySelector(".rook-product-list");
      const swiper = sliderContainer && sliderContainer.querySelector(".rook-mixed-layout__wrapper");
      const controlsContainer = sliderContainer.querySelector(".rook-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".rook-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".rook-slider-controls__button-next");
      const slideItemsLength =
        sliderContainer &&
        sliderContainer.querySelector(".swiper-wrapper") &&
        sliderContainer.querySelector(".swiper-wrapper").childElementCount;
      const deck = this.mobileDeck && slideItemsLength >= 3;
      // a short list still makes a deck on phones, even though it needs no slider on wider screens
      if (parseInt(this.items) >= slideItemsLength && !(deck && RookTheme.config.mqlMobile)) {
        controlsContainer && controlsContainer.classList.add("rook:hidden");
        layoutWrapper.classList.add("rook-mixed-layout--mobile-grid");
        return;
      }

      swiper && swiper.classList.add("swiper-container");

      let slider = new RookLibs.Swiper(swiper, {
        slidesPerView: deck ? 1.6 : 2,
        centeredSlides: deck,
        watchSlidesProgress: deck,
        speed: deck ? 450 : 300,
        showPagination: this.showPagination,
        showNavigation: this.showNavigation,
        loop: this.enableFlashsale ? false : true,
        pagination: this.showPagination
          ? {
              el: sliderContainer.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        // each breakpoint stands alone, so every one of them switches the phone deck off
        breakpoints: {
          768: {
            slidesPerView: parseInt(this.items) >= 3 ? 3 : parseInt(this.items),
            centeredSlides: false,
            speed: 300,
          },
          992: {
            slidesPerView: parseInt(this.items) >= 4 ? 4 : parseInt(this.items),
            centeredSlides: false,
            speed: 300,
          },
          1280: {
            slidesPerView: parseInt(this.items),
            centeredSlides: false,
            speed: 300,
          },
        },
        threshold: 2,
        on: {
          init: function () {
            setTimeout(() => {
              // Calculate controls position
              const firstItem =
                sliderContainer.querySelector(".rook-image") || sliderContainer.querySelector(".rook-placeholder-svg");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                prevButton.classList.remove("rook:hidden");
                nextButton.classList.remove("rook:hidden");
              }
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              if (slideItemsLength > slidesPerView) {
                controlsContainer.classList.remove("rook:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("rook:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      if (slider && this.showNavigation) {
        prevButton && prevButton.addEventListener("click", () => slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => slider.slideNext());
      }
      if (slider && deck) this.initDeck(slider, swiper);
    }

    // Phones: the slider becomes a fanned deck, the centre card upright and its neighbours tucked behind it
    initDeck(slider, container) {
      if (slider.deckReady) return;
      slider.deckReady = true;

      const fan = () => {
        const active = slider.params.centeredSlides;
        container.classList.toggle("rook-deck", active);
        for (let i = 0; i < slider.slides.length; i++) {
          const slide = slider.slides[i];
          if (!active) {
            ["--deck-p", "--deck-a", "z-index", "transition-duration"].forEach((prop) => slide.style.removeProperty(prop));
            continue;
          }
          // 0 = centre card, 1 = the card on its left, -1 = the card on its right
          const progress = Number.isFinite(slide.progress) ? Math.max(-2, Math.min(2, slide.progress)) : 0;
          slide.style.setProperty("--deck-p", progress.toFixed(3));
          slide.style.setProperty("--deck-a", Math.abs(progress).toFixed(3));
          slide.style.zIndex = 10 - Math.round(Math.abs(progress) * 4);
        }
      };
      slider.on("setTranslate progress update resize breakpoint", fan);
      slider.on("setTransition", (instance, duration) => {
        if (!slider.params.centeredSlides) return;
        for (let i = 0; i < slider.slides.length; i++) slider.slides[i].style.transitionDuration = duration + "ms";
      });
      // a tap on a side card brings it to the front instead of opening it
      container.addEventListener(
        "click",
        (event) => {
          if (!slider.params.centeredSlides) return;
          const slide = event.target.closest(".swiper-slide");
          if (!slide || slide.classList.contains("swiper-slide-active")) return;
          event.preventDefault();
          event.stopPropagation();
          slide.progress < 0 ? slider.slideNext() : slider.slidePrev();
        },
        true
      );
      fan();
    }

    initMobileSelect() {
      this.select = this.querySelector("[data-tab-select]");
      this.select.addEventListener("change", () => {
        this.tabs.setActiveTab(parseInt(this.select.value));
        const slider = this.tabs && this.tabs.currentTab && this.tabs.currentTab.querySelector(".swiper-container");
        const controlsContainer =
          this.tabs && this.tabs.currentTab && this.tabs.currentTab.querySelector(".rook-slider-controls");
        const prevButton = controlsContainer && controlsContainer.querySelector(".rook-slider-controls__button-prev");
        const nextButton = controlsContainer && controlsContainer.querySelector(".rook-slider-controls__button-next");
        slider && slider.swiper && slider.swiper.update();
        const firstItem = slider && slider.querySelector(".rook-image");
        if (firstItem && controlsContainer) {
          const itemHeight = firstItem.clientHeight;
          controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

          prevButton.classList.remove("rook:hidden");
          nextButton.classList.remove("rook:hidden");
        }
      });
    }

    initLoadMore(wrapper) {
      addEventDelegate({
        context: wrapper,
        selector: this.selectors.loadMoreBtn,
        handler: (e) => {
          e.preventDefault();
          this.handleLoadMore(wrapper);
        },
      });
    }

    handleLoadMore(wrapper) {
      const loadBtn = wrapper.querySelector(this.selectors.loadMoreBtn);
      const productsContainer = wrapper.querySelector(this.selectors.productsContainer);

      let currentPage = wrapper.dataset.page;
      currentPage = parseInt(currentPage);
      const totalPages = wrapper.dataset.totalPages;
      this.toggleLoading(loadBtn, true);

      const url = wrapper.dataset.url;
      const dataUrl = `${url}?page=${currentPage + 1}&section_id=${this.id}`;
      fetchCache(dataUrl).then((html) => {
        currentPage++;
        wrapper.dataset.page = currentPage;
        this.toggleLoading(loadBtn, false);
        const dom = generateDomFromString(html);
        const tabId = wrapper.getAttribute("id");
        const products = dom.querySelector(`#${tabId} ${this.selectors.productsContainer}`);

        if (products) {
          Array.from(products.childNodes).forEach((product) => productsContainer.appendChild(product));
        }

        if (currentPage >= parseInt(totalPages)) loadBtn && loadBtn.remove();
      });

      // Remove button focus
      loadBtn.blur();
    }

    toggleLoading(loadBtn, status) {
      if (!loadBtn) return;
      if (status) {
        loadBtn.classList.add("rook-spinner-loading");
      } else {
        loadBtn.classList.remove("rook-spinner-loading");
      }
    }
  }
  customElements.define("rook-product-tabs", MProductTabs);
}
